
import Button from '../base/Button';

export default function ProductSection() {
  return (
    <section id="produto" className="py-20 bg-gradient-to-br from-black via-gray-900 to-orange-900/20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative z-10">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20tilted%20computer%20monitor%20displaying%20business%20management%20software%20dashboard%20with%20charts%20and%20analytics%2C%20MPGBOX%20system%20interface%20on%20screen%2C%20sleek%20black%20monitor%20with%20orange%20accent%20lighting%2C%20professional%20workspace%20setup%2C%20business%20intelligence%20dashboard%20visible%20on%20tilted%20screen%2C%20corporate%20technology%20environment%2C%20clean%20modern%20design&width=600&height=500&seq=mpgbox-monitor&orientation=landscape"
                alt="MPGBOX - Sistema de gestão empresarial em monitor"
                className="w-full h-auto rounded-2xl shadow-2xl shadow-orange-500/30 object-cover"
              />
            </div>
            
            {/* Glow Effect */}
            <div className="absolute -inset-4 bg-gradient-to-r from-orange-500/30 to-orange-600/20 rounded-2xl blur-xl"></div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center bg-orange-500/20 text-orange-500 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-star-line mr-2"></i>
              Produto em Destaque
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Rofoto, sans-serif' }}>
              Conheça o
              <span className="text-orange-500 block">MPGBOX</span>
            </h2>
            
            <p className="text-xl text-gray-300 mb-8 leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Nosso sistema SaaS completo para micro e pequenas empresas. 
              Controle de estoque, vendas, produção e finanças em tempo real.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-center text-gray-300">
                <i className="ri-check-line text-orange-500 mr-3 text-xl"></i>
                <span>Gestão completa de estoque e produtos</span>
              </div>
              <div className="flex items-center text-gray-300">
                <i className="ri-check-line text-orange-500 mr-3 text-xl"></i>
                <span>Controle de vendas e faturamento</span>
              </div>
              <div className="flex items-center text-gray-300">
                <i className="ri-check-line text-orange-500 mr-3 text-xl"></i>
                <span>Relatórios financeiros em tempo real</span>
              </div>
              <div className="flex items-center text-gray-300">
                <i className="ri-check-line text-orange-500 mr-3 text-xl"></i>
                <span>Conheça seus melhores clientes</span>
              </div>
            </div>

            <Button size="lg" href="https://mpgbox.com.br" className="group">
              Acesse mpgbox.com.br
              <i className="ri-external-link-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
